// extracted by mini-css-extract-plugin
export var reactPlayerContainer = "blog-video-embed-module--reactPlayerContainer--dda87";
export var videoEmbedWrapper = "blog-video-embed-module--videoEmbedWrapper--7d6fd";